/* Fransk katalog for locale-advisor-reports-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('fr', {
  'adv.cf.cashBasisMissing': 'Les données de trésorerie ne sont pas disponibles. Les soldes et mouvements doivent pouvoir être rapprochés du grand livre.',
  'adv.cf.cashBalanceEvidence': 'Le solde de caisse et de banque comptabilisé est de {amount}. Il ne s\'agit pas d\'un solde confirmé par la banque.',
  'adv.rpt.period.profit': 'Au {quarter}e trimestre {year}, les produits s\'élèvent à {income} et le bénéfice à {result}.',
  'adv.rpt.period.loss': 'Au {quarter}e trimestre {year}, les produits s\'élèvent à {income} et la perte à {result}.',
  'adv.rpt.period.nativeSuppliers': 'La liste des fournisseurs porte sur les achats datés du trimestre, hors immobilisations et récapitulatifs annuels importés sans répartition trimestrielle.',
  'adv.rpt.period.choose': 'Période',
  'adv.rpt.period.year': 'Année entière',
  'adv.rpt.period.yearLabel': 'Année {year} entière',
  'adv.rpt.period.quarter': '{quarter}e trimestre',
  'adv.rpt.period.label': 'T{quarter} {year}',
  'adv.rpt.period.vsQuarter': 'par rapport au même trimestre de l\'année précédente',
  'adv.rpt.period.quarterBasis': 'Chiffres comptables du {from} au {to}. Le bilan présente les soldes à la fin de la période.',
  'adv.rpt.period.currentStatus': 'Statut de suivi à la génération du rapport le {date}. Cette partie utilise les postes ouverts actuels et l\'aperçu annuel, et non le statut historique en fin de trimestre.',
  'adv.rpt.period.rolling': '12 mois glissants jusqu\'au {to}, comparés aux 12 mois précédents.',
  'adv.rpt.period.nativeSales': 'Les détails clients et factures portent sur les factures comptabilisées datées du trimestre. Les récapitulatifs annuels importés sans répartition trimestrielle ne sont pas inclus ici.',
  'adv.rpt.period.budget': 'Le réalisé du trimestre sélectionné est comparé au budget des trois mêmes mois.',
  'adv.rpt.period.pdfUnavailable': 'La nouvelle mise en page PDF n\'est pas encore disponible sur le serveur. Réessayez après la mise à jour.',
  'adv.rpt.slides.present': 'Présenter',
  'adv.rpt.slides.exit': 'Quitter la présentation',
  'adv.rpt.slides.readable': 'Lire le texte de la page',
  'adv.rpt.slides.previous': 'Précédent',
  'adv.rpt.slides.next': 'Suivant',
  'adv.rpt.slides.page': 'Page {current} sur {total}',
  'adv.rpt.modal.title': 'Créer un rapport',
  'adv.rpt.modal.intro': 'Choisissez un modèle de rapport. SuperPlumma récupère les chiffres de votre comptabilité et prépare un brouillon que vous pouvez relire avant de le partager.',
  'adv.rpt.modal.generate': 'Générer le rapport',
  'adv.rpt.modal.cancel': 'Annuler',
  'adv.rpt.modal.basis': 'Données utilisées : {sources}',
  'adv.rpt.modal.year': 'Exercice',
  'adv.rpt.modal.saved': 'Rapports enregistrés',
  'adv.rpt.modal.savedEmpty': 'Vous n\'avez encore aucun rapport enregistré.',
  'adv.rpt.modal.open': 'Ouvrir',
  'adv.rpt.modal.delete': 'Supprimer',
  'adv.rpt.modal.deleted': 'Le rapport a été supprimé.',
  'adv.rpt.hero.cta': 'Créer un rapport',
  'adv.rpt.saved.title': 'Rapports enregistrés',
  'adv.rpt.saved.tab': 'Rapports enregistrés',
  'adv.rpt.saved.description': 'Les rapports que vous enregistrez sont conservés comme instantanés et ne changent pas lorsque la comptabilité est mise à jour.',
  'adv.rpt.saved.count': '{count} rapports enregistrés sur {limit}',
  'adv.rpt.saved.limitError': 'Vous pouvez enregistrer au maximum {limit} rapports. Supprimez un rapport avant d\'en enregistrer un nouveau.',
  'adv.rpt.saved.loading': 'Chargement des rapports enregistrés …',
  'adv.rpt.saved.emptyTitle': 'Aucun rapport enregistré',
  'adv.rpt.saved.emptyText': 'Créez un rapport et enregistrez-le lorsque vous souhaitez conserver cette version précise.',
  'adv.rpt.saved.loadFailed': 'Impossible de charger les rapports enregistrés.',
  'adv.rpt.saved.deleteFailed': 'Impossible de supprimer le rapport.',
  'adv.rpt.tpl.styre.name': 'Rapport au conseil et à la direction',
  'adv.rpt.tpl.styre.desc': 'Rapport complet pour le conseil d\'administration avec résultat, liquidité, risques et actions recommandées.',
  'adv.rpt.tpl.manedsrapport.name': 'Rapport mensuel',
  'adv.rpt.tpl.manedsrapport.desc': 'Situation du mois sélectionné avec budget, comparaison avec l\'année précédente, tendance et prochaines étapes recommandées.',
  'adv.rpt.tpl.likviditet.name': 'Rapport de trésorerie',
  'adv.rpt.tpl.likviditet.desc': 'Postes ouverts, réserve et solde courant basés sur les chiffres comptabilisés.',
  'adv.rpt.tpl.avvik.name': 'Rapport de résultat et d\'écarts',
  'adv.rpt.tpl.avvik.desc': 'Les écarts les plus importants par rapport au budget depuis le début de l\'année, et les postes de charges qui ont le plus évolué.',
  'adv.rpt.tpl.kunde.name': 'Rapport clients et ventes',
  'adv.rpt.tpl.kunde.desc': 'Évolution des ventes, principaux clients, concentration de la clientèle et créances en cours.',
  'adv.rpt.tpl.kostnad.name': 'Rapport des charges',
  'adv.rpt.tpl.kostnad.desc': 'Évolution des charges, principaux fournisseurs et justificatifs sans documentation.',
  'adv.rpt.tpl.utestaende.name': 'Postes ouverts',
  'adv.rpt.tpl.utestaende.desc': 'Postes clients et fournisseurs impayés, répartis entre échus et non échus.',
  'adv.rpt.tpl.arsoppsummering.name': 'Bilan de l\'année',
  'adv.rpt.tpl.arsoppsummering.desc': 'Résume toute l\'année — résultat, bilan, ventes, charges et risques.',
  'adv.rpt.length.2to3': '2–3 pages',
  'adv.rpt.length.2to4': '2–4 pages',
  'adv.rpt.length.3to5': '3–5 pages',
  'adv.rpt.length.4to6': '4–6 pages',
  'adv.rpt.length.8to12': '8–12 pages',
  'adv.rpt.length.variable': 'Longueur selon les données disponibles',
  'adv.rpt.length.10to14': '10–14 pages',
  'adv.rpt.doc.contents': 'Sommaire',
  'adv.rpt.doc.brand': 'PLUMME / AI CONSEILLER',
  'adv.rpt.doc.continued': 'suite',
  'adv.rpt.doc.back': 'Retour',
  'adv.rpt.doc.draft': 'Brouillon',
  'adv.rpt.doc.saved': 'Enregistré',
  'adv.rpt.doc.save': 'Enregistrer',
  'adv.rpt.doc.savedToast': 'Le rapport a été enregistré.',
  'adv.rpt.doc.exportPdf': 'Exporter en PDF',
  'adv.rpt.doc.exportPptx': 'Télécharger le PowerPoint',
  'adv.rpt.doc.exportingPptx': 'Création du PowerPoint …',
  'adv.rpt.doc.exportPptxFailed': 'Impossible de créer le fichier PowerPoint. Réessayez.',
  'adv.rpt.doc.presentation': 'PRÉSENTATION',
  'adv.rpt.doc.coverFoot': 'Généré à partir des données du rapport dans Plumme',
  'adv.rpt.doc.exporting': 'Création du PDF …',
  'adv.rpt.doc.exportFailed': 'Impossible de créer le fichier du rapport. Réessayez.',
  'adv.rpt.doc.period': '{year} · {months} mois de l\'année',
  'adv.rpt.doc.createTask': 'Créer une tâche',
  'adv.rpt.doc.taskCreated': 'Ajoutée au centre d\'actions avec un suivi le {date}.',
  'adv.rpt.doc.taskFailed': 'Impossible de créer la tâche.',
  'adv.rpt.doc.taskNote': 'Créée à partir de {report}.',
  'adv.rpt.narr.section': 'Synthèse de SuperPlumma',
  'adv.rpt.narr.tag': 'Rédigé par SuperPlumma',
  'adv.rpt.narr.idle': 'Laissez SuperPlumma lire le rapport et rédiger la synthèse : les enjeux, ce qui a réellement évolué et ce que vous devriez faire maintenant.',
  'adv.rpt.narr.write': 'Rédiger la synthèse',
  'adv.rpt.narr.rewrite': 'Réécrire',
  'adv.rpt.narr.loading': 'SuperPlumma lit le rapport …',
  'adv.rpt.narr.failed': 'Impossible de rédiger la synthèse. Les chiffres du rapport restent complets.',
  'adv.rpt.narr.drivers': 'Ce qui a évolué',
  'adv.rpt.narr.watch': 'Points à surveiller',
  'adv.rpt.narr.nextStep': 'Prochaine étape : ',
  'adv.rpt.narr.foot': 'La synthèse est rédigée à partir des chiffres du rapport. Tous les montants sont vérifiés par rapport au rapport avant l\'affichage du texte.',
  'adv.rpt.sec.changeSince': 'Évolutions depuis le dernier rapport',
  'adv.rpt.col.lastReport': 'Dernier rapport',
  'adv.rpt.col.now': 'Maintenant',
  'adv.rpt.col.change': 'Évolution',
  'adv.rpt.note.changeSinceBasis': 'Comparé au rapport enregistré le {date}. Ses chiffres sont un instantané et ne changent pas par la suite.',
  'adv.rpt.empty.noPreviousReport': 'Il s\'agit du premier rapport enregistré de ce type pour l\'année. La prochaine fois, cette section montrera ce qui a changé depuis maintenant.',
  'adv.rpt.empty.noComparableReport': 'Le rapport précédent ne contient aucun chiffre clé à comparer.',
  'adv.rpt.sec.summary': 'Synthèse',
  'adv.rpt.sec.events': 'Événements significatifs',
  'adv.rpt.sec.keyFigures': 'Chiffres clés financiers',
  'adv.rpt.sec.budget': 'Résultat par rapport au budget',
  'adv.rpt.sec.liquidity': 'Liquidité et engagements de paiement',
  'adv.rpt.sec.forecast': 'Solde courant au fil de l\'année',
  'adv.rpt.sec.balance': 'Bilan et solidité financière',
  'adv.rpt.sec.resultTrend': 'Évolution du résultat',
  'adv.rpt.sec.sales': 'Évolution des ventes et des clients',
  'adv.rpt.sec.customerChange': 'Fidélité des clients et délais de paiement',
  'adv.rpt.sec.costTrend': 'Évolution des charges',
  'adv.rpt.sec.suppliers': 'Principaux fournisseurs',
  'adv.rpt.sec.voucherReview': 'Justificatifs à examiner',
  'adv.rpt.sec.receivables': 'Postes clients',
  'adv.rpt.sec.payables': 'Postes fournisseurs',
  'adv.rpt.sec.risk': 'Risques et incertitudes',
  'adv.rpt.sec.actions': 'Actions recommandées',
  'adv.rpt.sec.decisions': 'Points à décider',
  'adv.rpt.sec.dataBasis': 'Données utilisées',
  'adv.rpt.sec.bridge': 'Ce qui a fait évoluer le résultat',
  'adv.rpt.sec.workingCapital': 'Fonds de roulement et durée d\'immobilisation',
  'adv.rpt.sec.rolling': '12 mois glissants',
  'adv.rpt.col.driver': 'Facteur',
  'adv.rpt.col.effect': 'Effet',
  'adv.rpt.col.priority': 'Priorité',
  'adv.rpt.bridge.opening': 'Résultat {year}',
  'adv.rpt.bridge.closing': 'Résultat {year}',
  'adv.rpt.bridge.revenue': 'Évolution des produits',
  'adv.rpt.bridge.finance': 'Évolution du résultat financier',
  'adv.rpt.bridge.other': 'Autres postes ({count} lignes)',
  'adv.rpt.bridge.readGuide': 'Lisez de gauche à droite : commencez par le résultat de l’an dernier. Le vert augmente le résultat, le rouge le diminue. La dernière barre est le résultat de l’année. Les montants ci-dessous indiquent chaque contribution.',
  'adv.rpt.bridge.readShort': 'De l’an dernier à cette année · Le vert augmente le résultat · Le rouge le diminue',
  'adv.rpt.note.bridgeBasis': 'Les lignes dont l’effet est inférieur à {amount} sont regroupées. Le pont va du résultat {year} au résultat de cette année, et la somme des facteurs correspond à la variation totale.',
  'adv.rpt.empty.noBridgeBasis': 'Sans chiffres comptabilisés pour {year}, la variation ne peut pas être ventilée par facteur.',
  'adv.rpt.empty.noBridgeChange': 'Le résultat est inchangé par rapport à {year}.',
  'adv.rpt.metric.receivableDays': 'Créances clients',
  'adv.rpt.metric.payableDays': 'Dettes fournisseurs',
  'adv.rpt.metric.capitalGap': 'Durée d’immobilisation nette',
  'adv.rpt.metric.measuredPaymentDays': 'Délai de paiement réel',
  'adv.rpt.metric.netCapitalTied': 'Capital immobilisé net',
  'adv.rpt.note.capitalGapPositive': 'Vous attendez votre argent {days} jours de plus que le temps que vous mettez à payer. C’est la période pendant laquelle l’activité doit être financée par votre propre trésorerie.',
  'adv.rpt.note.capitalGapNegative': 'Vous payez plus tard que vous n’êtes payé. Le crédit fournisseur finance alors une partie de l’activité.',
  'adv.rpt.note.capitalGapUnknown': 'La durée d’immobilisation nette ne peut pas être calculée, car la base de revenus ou de charges est manquante.',
  'adv.rpt.note.workingCapitalBasis': 'Les jours clients et fournisseurs sont des estimations fondées sur les postes ouverts et {months} mois de l’exercice. Le délai de paiement réel est mesuré uniquement sur les factures clients payées et ne correspond donc pas au même calcul.',
  'adv.rpt.empty.noWorkingCapital': 'Aucun poste client ou fournisseur ouvert permettant de mesurer la durée d’immobilisation.',
  'adv.rpt.cell.vsPrevious12': 'vs 12 précédents',
  'adv.rpt.note.rollingBasis': 'La fenêtre couvre les {months} derniers mois comptabilisés : la comparaison traverse le changement d’année et n’est pas affectée par la saisonnalité.',
  'adv.rpt.note.noRollingComparison': 'L’historique est insuffisant pour comparer avec les 12 mois précédents.',
  'adv.rpt.empty.noRollingBasis': 'Historique comptabilisé insuffisant pour construire une fenêtre glissante de 12 mois.',
  'adv.rpt.certainty.planned': 'Prévu',
  'adv.rpt.summary.profit': 'Après {months} mois de {year}, {income} de produits ont été comptabilisés, pour un bénéfice de {result}.',
  'adv.rpt.summary.loss': 'Après {months} mois de {year}, {income} de produits ont été comptabilisés, pour une perte de {result}.',
  'adv.rpt.summary.margin': 'Cela donne une marge bénéficiaire de {margin} %.',
  'adv.rpt.kpi.income': 'Produits',
  'adv.rpt.kpi.costs': 'Charges',
  'adv.rpt.kpi.result': 'Résultat',
  'adv.rpt.kpi.margin': 'Marge bénéficiaire',
  'adv.rpt.kpi.revenue': 'Ventes facturées',
  'adv.rpt.kpi.invoiceCount': 'Nombre de factures',
  'adv.rpt.kpi.avgInvoice': 'Moyenne par facture',
  'adv.rpt.kpi.customerCount': 'Nombre de clients',
  'adv.rpt.metric.receivables': 'Encours clients',
  'adv.rpt.metric.payables': 'Dû aux fournisseurs',
  'adv.rpt.metric.buffer': 'Réserve de trésorerie',
  'adv.rpt.metric.lowestBalance': 'Solde le plus bas de l’année',
  'adv.rpt.metric.assets': 'Total des actifs',
  'adv.rpt.metric.equityAndDebt': 'Total capitaux propres et dettes',
  'adv.rpt.metric.solidity': 'Ratio de capitaux propres',
  'adv.rpt.metric.repeatRate': 'Part de clients fidèles',
  'adv.rpt.metric.avgPaymentDays': 'Délai de paiement moyen',
  'adv.rpt.unit.days': '{days} jours',
  'adv.rpt.col.line': 'Ligne',
  'adv.rpt.col.account': 'Compte',
  'adv.rpt.col.budgetToDate': 'Budget à date',
  'adv.rpt.col.actual': 'Comptabilisé',
  'adv.rpt.col.variance': 'Écart',
  'adv.rpt.col.month': 'Mois',
  'adv.rpt.col.in': 'Entrées',
  'adv.rpt.col.out': 'Sorties',
  'adv.rpt.col.balance': 'Solde',
  'adv.rpt.col.certainty': 'Base',
  'adv.rpt.col.income': 'Produits',
  'adv.rpt.col.costs': 'Charges',
  'adv.rpt.col.result': 'Résultat',
  'adv.rpt.col.share': 'Part',
  'adv.rpt.chart.budgetActual': 'Budget vs comptabilisé à date',
  'adv.rpt.chart.monthlyResult': 'Résultat par mois',
  'adv.rpt.chart.incomeCosts': 'Produits et charges par mois',
  'adv.rpt.chart.summaryResult': 'Des produits au résultat',
  'adv.rpt.chart.keyFiguresComparison': 'Chiffres clés vs l’an dernier',
  'adv.rpt.chart.previousPeriod': 'Période précédente',
  'adv.rpt.chart.currentPeriod': 'Période actuelle',
  'adv.rpt.chart.cumulativeResult': 'Résultat cumulé sur l’année',
  'adv.rpt.chart.runningBalance': 'Solde courant et réserve de trésorerie',
  'adv.rpt.chart.openItemsDue': 'Postes ouverts par échéance',
  'adv.rpt.chart.workingCapitalGap': 'Capital immobilisé dans les postes ouverts',
  'adv.rpt.chart.balanceBasis': 'Groupes de bilan comptabilisés',
  'adv.rpt.chart.bookedBalance': 'Solde comptabilisé',
  'adv.rpt.chart.capitalStructure': 'Structure du capital',
  'adv.rpt.chart.equityShare': 'Capitaux propres',
  'adv.rpt.chart.otherFinancing': 'Autres financements',
  'adv.rpt.chart.profit': 'Bénéfice',
  'adv.rpt.chart.loss': 'Perte',
  'adv.rpt.col.amount': 'Montant',
  'adv.rpt.col.changeYoy': 'Variation vs l’an dernier',
  'adv.rpt.col.status': 'Statut',
  'adv.rpt.row.income': 'Produits',
  'adv.rpt.row.costs': 'Charges',
  'adv.rpt.row.notDue': 'Non échu',
  'adv.rpt.row.current': 'Non échu',
  'adv.rpt.row.overdue': 'Échu',
  'adv.rpt.row.total': 'Total',
  'adv.rpt.cell.vsPreviousYear': 'vs l’an dernier',
  'adv.rpt.cell.noBasis': 'Aucune comparaison',
  'adv.rpt.month.jan': 'Janvier',
  'adv.rpt.month.feb': 'Février',
  'adv.rpt.month.mar': 'Mars',
  'adv.rpt.month.apr': 'Avril',
  'adv.rpt.month.may': 'Mai',
  'adv.rpt.month.jun': 'Juin',
  'adv.rpt.month.jul': 'Juillet',
  'adv.rpt.month.aug': 'Août',
  'adv.rpt.month.sep': 'Septembre',
  'adv.rpt.month.oct': 'Octobre',
  'adv.rpt.month.nov': 'Novembre',
  'adv.rpt.month.dec': 'Décembre',
  'adv.rpt.certainty.confirmed': 'Comptabilisé',
  'adv.rpt.certainty.expected': 'Mois en cours',
  'adv.rpt.certainty.uncertain': 'Pas encore comptabilisé',
  'adv.rpt.budget.intro': 'Les chiffres comptabilisés pour {months} mois de {year} sont comparés au budget des mêmes mois, et non au budget de l’année entière.',
  'adv.rpt.vouchers.missing': '{count} achats comptabilisés n’ont pas de justificatif. Au total, cela concerne {net} de base et {vat} de TVA déduite.',
  'adv.rpt.action.impact': '{label} : {value}',
  'adv.rpt.priority.high': 'Élevée',
  'adv.rpt.priority.medium': 'Moyenne',
  'adv.rpt.priority.low': 'Faible',
  'adv.rpt.severity.critical': 'Critique',
  'adv.rpt.severity.watch': 'À suivre',
  'adv.rpt.severity.info': 'Pour information',
  'adv.rpt.decision.risk': 'À trancher : {name}',
  'adv.rpt.decision.opportunity': 'À envisager : {name}',
  'adv.rpt.decision.freeCapital': 'Décidez de l’utilisation du capital disponible de {amount}.',
  'adv.rpt.note.noPreviousYear': 'Aucun chiffre n’est comptabilisé pour {year} : la variation par rapport à l’an dernier ne peut pas être calculée.',
  'adv.rpt.note.partialYear': 'La période n’est pas clôturée. Les chiffres couvrent {months} mois de {year}.',
  'adv.rpt.note.noMaterialVariance': 'Aucune ligne ne s’écarte significativement du budget.',
  'adv.rpt.note.unbudgeted': '{count} comptes ont des montants comptabilisés sans ligne budgétaire. Ils sont inclus dans le total.',
  'adv.rpt.note.belowBuffer': 'Le solde calculé le plus bas est de {lowest}, en dessous de l’objectif de réserve choisi de {buffer}.',
  'adv.rpt.note.aboveBuffer': 'Le solde courant reste au-dessus de la réserve de {buffer} pendant toute la période.',
  'adv.rpt.note.forecastIsBooked': 'La courbe est un solde courant des chiffres comptabilisés, pas un modèle de prévision. Les mois sans écriture restent plats.',
  'adv.rpt.note.balanceGrouping': 'Les capitaux propres et les dettes sont présentés ensemble, comme dans la balance générale.',
  'adv.rpt.note.balanceInterimBasis': 'Les groupes de bilan sont présentés tels qu’ils sont comptabilisés à la date du rapport. L’écart entre les deux côtés peut inclure le résultat de la période et ne doit pas être lu comme un bilan annuel définitif.',
  'adv.rpt.note.noCustomerSplit': 'Les ventes ne sont pas ventilées par client dans les données de base.',
  'adv.rpt.note.concentration': '{name} représente {pct} % des ventes facturées.',
  'adv.rpt.note.customerBasis': 'Le délai de paiement est mesuré sur les factures effectivement payées.',
  'adv.rpt.note.costJump': 'Une ou plusieurs lignes de charges ont augmenté de plus de 25 % par rapport à l’an dernier.',
  'adv.rpt.note.topFiveOnly': 'Affiche les cinq plus importants. Les autres sont inclus dans les totaux, mais pas listés.',
  'adv.rpt.note.vouchersComplete': 'Tous les achats comptabilisés ont un justificatif.',
  'adv.rpt.note.vouchersRequired': 'Le bokføringsloven exige une pièce justificative pour chaque écriture. Les justificatifs manquants doivent être obtenus avant la déclaration de la période.',
  'adv.rpt.note.overdueSales': '{amount} est échu côté clients et doit faire l’objet d’un suivi.',
  'adv.rpt.note.overduePurchases': '{amount} est échu côté fournisseurs.',
  'adv.rpt.note.noRisks': 'Aucun risque n’a été détecté dans les chiffres comptabilisés.',
  'adv.rpt.note.noActions': 'Aucune action n’est recommandée pour le moment.',
  'adv.rpt.note.notAProtocol': 'Il s’agit d’une aide à la décision qui ne remplace pas un procès-verbal du conseil. Les décisions sont prises par le conseil d’administration.',
  'adv.rpt.empty.noBookkeeping': 'Aucun produit ni aucune charge n’est comptabilisé pour {year}. Le rapport affichera des chiffres dès qu’il y aura des justificatifs.',
  'adv.rpt.empty.noEvents': 'Aucune évolution significative n\'a été enregistrée sur la période.',
  'adv.rpt.empty.noBudget': 'Il n\'existe aucun budget pour {year}. Saisissez un budget pour obtenir les écarts dans le rapport.',
  'adv.rpt.empty.noLiquidityBasis': 'Aucun poste client ou fournisseur ouvert, et aucun mouvement comptabilisé sur lequel établir le solde.',
  'adv.rpt.empty.noForecast': 'Aucune base de trésorerie rapprochée n\'est disponible pour la courbe de solde.',
  'adv.rpt.empty.noBalance': 'La balance générale de {year} est vide.',
  'adv.rpt.empty.noSales': 'Aucune vente facturée n\'est comptabilisée pour {year}.',
  'adv.rpt.empty.noCustomerHistory': 'Historique client insuffisant pour mesurer les achats répétés et les délais de paiement.',
  'adv.rpt.empty.noCosts': 'Aucune charge n\'est comptabilisée pour {year}.',
  'adv.rpt.empty.noSupplierSplit': 'Les charges ne sont pas réparties par fournisseur dans les données.',
  'adv.rpt.empty.noReceivables': 'Aucun poste client en cours.',
  'adv.rpt.empty.noPayables': 'Aucun poste fournisseur en cours.',
  'adv.rpt.empty.noDecisions': 'Aucun point ne nécessite de décision pour le moment.',
  'adv.rpt.source.result': 'Compte de résultat',
  'adv.rpt.source.balance': 'Balance générale',
  'adv.rpt.source.openItems': 'Postes clients et fournisseurs ouverts',
  'adv.rpt.source.budget': 'Budget',
  'adv.rpt.source.bank': 'Mouvements bancaires',
  'adv.rpt.source.invoices': 'Factures clients',
  'adv.rpt.source.purchases': 'Factures fournisseurs',
  'adv.rpt.source.vouchers': 'Justificatifs',
  'adv.rpt.basis.generated': 'Généré le {date}.',
  'adv.rpt.basis.period': 'La période couvre {months} mois de {year}.',
  'adv.rpt.basis.noPreviousYear': 'Aucun chiffre comptabilisé pour {year} — la comparaison avec l\'année précédente est indisponible.',
  'adv.rpt.basis.noBudget': 'Aucune ligne budgétaire pour {year}.',
  'adv.rpt.basis.noPartySplit': 'La répartition par client et fournisseur est incomplète. L\'aperçu clients présente ce qui peut être rattaché aux ventes facturées.',
  'adv.rpt.basis.topFive': 'Les listes de clients et de fournisseurs affichent les cinq plus importants.',
  'adv.rpt.basis.bookedOnly': 'Les chiffres comptables proviennent de la comptabilité. La réserve est un objectif, pas un solde comptabilisé. Les paiements prévus et les indicateurs calculés sont signalés dans le rapport.',
  'adv.rpt.period.monthShort': '{month}/{year}',
  'adv.rpt.period.vsPreviousMonth': 'par rapport au mois précédent',
  'adv.rpt.monthPicker.title': 'Choisir le mois du rapport mensuel',
  'adv.rpt.monthPicker.intro': 'Choisissez l\'un des 24 derniers mois calendaires. Le rapport utilise uniquement les chiffres comptabilisés, le budget et les comparaisons du mois sélectionné.',
  'adv.rpt.monthPicker.separate': 'Le rapport mensuel dispose de sa propre sélection de mois et n\'est pas affecté par la sélection d\'année ou de trimestre des autres rapports.',
  'adv.rpt.monthPicker.continue': 'Choisir le mois',
  'adv.rpt.monthPicker.back': 'Retour aux modèles de rapport',
  'adv.rpt.monthPicker.generate': 'Générer le rapport mensuel',
  'adv.rpt.sec.monthlyStatus': 'Situation du mois',
  'adv.rpt.sec.monthlyBudget': 'Mois par rapport au budget',
  'adv.rpt.sec.monthlyComparison': 'Même mois l\'an dernier',
  'adv.rpt.sec.monthlyTrend': 'Évolution sur les 12 derniers mois',
  'adv.rpt.sec.monthlyInsights': 'Évaluation du mois et prochaines étapes',
  'adv.rpt.empty.noMonthlyBudget': 'Il n\'existe aucun budget pour le mois sélectionné.',
  'adv.rpt.empty.noMonthlyComparison': 'Il n\'existe aucun chiffre comptabilisé pour le même mois l\'an dernier.',
  'adv.rpt.empty.noMonthlyTrend': 'Il n\'existe aucun chiffre mensuel comptabilisé sur la fenêtre de douze mois.',
  'adv.rpt.col.budget': 'Budget',
  'adv.rpt.col.variancePct': 'Écart en %',
  'adv.rpt.row.result': 'Résultat',
  'adv.rpt.chart.monthBudgetActual': 'Budget et réalisé du mois',
  'adv.rpt.chart.sameMonthComparison': 'Mois sélectionné par rapport au même mois l\'an dernier',
  'adv.rpt.metric.averageMonthlyResult': 'Résultat mensuel moyen',
  'adv.rpt.metric.bestMonthlyResult': 'Meilleur mois',
  'adv.rpt.metric.weakestMonthlyResult': 'Mois le plus faible',
  'adv.rpt.monthly.statusProfit': 'Le mois s\'est terminé par un bénéfice de {result} et une marge de {margin} %.',
  'adv.rpt.monthly.statusLoss': 'Le mois s\'est terminé par une perte de {result} et une marge de {margin} %.',
  'adv.rpt.monthly.budgetAbove': 'Le résultat est supérieur de {amount} au budget du mois.',
  'adv.rpt.monthly.budgetBelow': 'Le résultat est inférieur de {amount} au budget du mois.',
  'adv.rpt.monthly.marginChange': 'La marge a évolué de {change} points de pourcentage par rapport au même mois l\'an dernier.',
  'adv.rpt.monthly.trendBasis': 'L\'évolution présente jusqu\'à 12 mois calendaires comptabilisés jusqu\'au mois sélectionné inclus.',
  'adv.rpt.monthly.insightLossTitle': 'Résultat mensuel négatif',
  'adv.rpt.monthly.insightLossBody': 'Les charges ont dépassé les produits de {amount} sur le mois sélectionné.',
  'adv.rpt.monthly.insightProfitTitle': 'Résultat mensuel positif',
  'adv.rpt.monthly.insightProfitBody': 'Le mois a dégagé un bénéfice de {amount}. Identifiez les produits et charges qui devraient se reproduire.',
  'adv.rpt.monthly.insightIncomeDownTitle': 'Produits inférieurs à l\'an dernier',
  'adv.rpt.monthly.insightIncomeDownBody': 'Les produits sont inférieurs de {change} % au même mois l\'an dernier.',
  'adv.rpt.monthly.insightCostsTitle': 'Charges supérieures au budget',
  'adv.rpt.monthly.insightCostsBody': 'Les charges dépassent de {amount} le budget du mois.',
  'adv.rpt.monthly.insightBudgetTitle': 'Résultat en retard sur le budget',
  'adv.rpt.monthly.insightBudgetBody': 'Le résultat est inférieur de {amount} au budget du mois.',
  'adv.rpt.monthly.stepReviewDrivers': 'Passez en revue les postes qui expliquent le résultat du mois et déterminez ce qui est durable.',
  'adv.rpt.monthly.stepRevenue': 'Analysez la baisse des produits par rapport au même mois l\'an dernier.',
  'adv.rpt.monthly.stepCosts': 'Identifiez les charges qui dépassent le budget mensuel.',
  'adv.rpt.monthly.stepBudget': 'Mettez à jour les actions pour combler l\'écart de résultat par rapport au budget mensuel.',
  'adv.rpt.monthly.stepContinue': 'Préservez les facteurs du résultat mensuel positif et suivez l\'évolution le mois prochain.',
});
